(function () {
  function init() {
    const picker = document.querySelector('.bulk-order-picker');
    if (!picker) return;

    const sectionId = picker.dataset.section;
    const sizeOptionIndex = parseInt(picker.dataset.sizeOptionIndex, 10);

    let variants;
    try {
      variants = JSON.parse(
        document.getElementById(`BulkOrderVariants-${sectionId}`)?.textContent || '[]'
      );
    } catch {
      return;
    }

    function getItems() {
      const selectedOptions = getSelectedOptions(sectionId);
      const items = [];
      picker.querySelectorAll('.bulk-order-picker__input').forEach((input) => {
        const qty = parseInt(input.value, 10) || 0;
        if (qty <= 0) return;
        const variant = findVariant(variants, sizeOptionIndex, input.dataset.sizeValue, selectedOptions);
        if (variant) items.push({ id: variant.id, quantity: qty });
      });
      return items;
    }

    function attachClickListener() {
      const btn = document.querySelector('[data-quotify]');
      if (!btn || btn.dataset.bulkSynced) return;
      btn.dataset.bulkSynced = 'true';

      btn.addEventListener('click', async (evt) => {
        const items = getItems();
        if (!items.length) return;

        evt.stopImmediatePropagation();
        evt.preventDefault();
        btn.disabled = true;

        try {
          // Store variant prices so the Quotify iframe can request them
          window._bulkOrderPrices = {};
          items.forEach((item) => {
            const v = variants.find((v) => v.id === item.id);
            if (v) window._bulkOrderPrices[item.id] = v.price;
          });

          // Clear cart first so old items don't appear in the quote
          await fetch(window.Shopify.routes.root + 'cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          });

          // Add selected sizes to cart
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });

          // Open Quotify quote popup with cart contents
          await quotifyConvertCart();
        } catch (err) {
          console.error('Bulk quote error:', err);
        } finally {
          btn.disabled = false;
        }
      }, true);
    }

    // ── Out-of-stock indicators ─────────────────────────────────────────────
    function updateStockStatus() {
      const selectedOptions = getSelectedOptions(sectionId);
      picker.querySelectorAll('.bulk-order-picker__item[data-size-value]').forEach((item) => {
        const sizeValue = item.dataset.sizeValue;
        const variant = findVariant(variants, sizeOptionIndex, sizeValue, selectedOptions);
        const input = item.querySelector('.bulk-order-picker__input');
        const soldOut = variant ? !variant.available : true;

        // Mark visually but keep input enabled so customer can still order
        item.classList.toggle('is-sold-out', soldOut);
        if (input) input.disabled = false;
      });
    }

    // Run on init, then re-run whenever the selected colour changes
    updateStockStatus();
    document.addEventListener('change', (e) => {
      if (e.target.closest(`#variant-selects-${sectionId}`)) {
        updateStockStatus();
      }
    });

    // Also re-run after Dawn swaps variant-selects (parent childList mutation)
    const variantSelectsParent = document.getElementById(`variant-selects-${sectionId}`)?.parentNode;
    if (variantSelectsParent) {
      new MutationObserver(() => {
        // Small delay so Dawn finishes updating the new element's checked state
        setTimeout(updateStockStatus, 50);
      }).observe(variantSelectsParent, { childList: true });
    }

    attachClickListener();

    const observer = new MutationObserver(attachClickListener);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function getSelectedOptions(sectionId) {
    const variantSelects = document.getElementById(`variant-selects-${sectionId}`);
    if (!variantSelects) return {};
    const options = {};
    variantSelects.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      const match = input.name.match(/options\[(.+)\]/);
      if (match) options[match[1].toLowerCase()] = input.value;
    });
    variantSelects.querySelectorAll('select').forEach((select) => {
      const match = select.name.match(/options\[(.+)\]/);
      if (match) options[match[1].toLowerCase()] = select.value;
    });
    return options;
  }

  function findVariant(variants, sizeOptionIndex, sizeValue, selectedOptions) {
    return variants.find((v) => {
      if (v.options[sizeOptionIndex] !== sizeValue) return false;
      for (const [name, value] of Object.entries(selectedOptions)) {
        if (name === 'size') continue;
        if (!v.options.some((opt) => opt === value)) return false;
      }
      return true;
    });
  }

  // Respond to price requests from the Quotify iframe
  window.addEventListener('message', function (e) {
    if (e.data && e.data.type === 'bulk-order-request-prices') {
      const source = e.source;
      if (source) {
        source.postMessage(
          { type: 'bulk-order-prices', prices: window._bulkOrderPrices || {} },
          '*'
        );
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
